import React from "react";
import { Trash2 } from "lucide-react";
import "./ButtonDelete.css";
import { useTranslation } from "react-i18next";

export default function ButtonDelete({
  onClick,
  ariaLabel,
  disabled = false,
  className = "",
  children,
  type = "button",
  style,
  withIcon = true,
  iconSize = 20,
}) {
  const { t } = useTranslation('common');
  const computedLabel = children ?? t('buttons.delete');
  const computedAria = ariaLabel ?? computedLabel;
  return (
    <button
      type={type}
      onClick={onClick}
      aria-label={computedAria}
      disabled={disabled}
      className={`user-modal-btn user-modal-btn-danger user-level-modal-btn user-level-modal-btn-danger ${className}`.trim()}
      style={style}
    >
      {withIcon && <Trash2 size={iconSize} aria-hidden="true" />}
      {computedLabel}
    </button>
  );
}
